import React, { useEffect } from 'react'
import styled, { ITheme } from '../../theme'
import airbnb from '../../assets/integrations/airbnb.svg'
import { Title } from './Help'
import { useTranslation } from 'react-i18next'
import check from '../../assets/integrations/check.svg'
import { AirbnbButton } from './Tabs/LoginAirbnb'
import { SquareCheckbox } from '../../components/FormBuilder'
import lockdown from '../../assets/integrations/lockdown.svg'
import currency from '../../assets/integrations/currency.svg'
import duplicate from '../../assets/integrations/duplicate.svg'
import { useDispatch, useSelector } from 'react-redux'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import { getAirbnbAgreement } from '../../reducers/airbnb/selectors'
import { is } from '../../components/MediaQuery'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 30px;
  padding-right: 30px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    padding-right: 15px;
  }
`

const Card = styled.div`
  width: 100%;
  background-color: #ebedef;
  border-radius: 5px;
  padding: 15px;
  margin-top: 30px;
`

const CardContent = styled.div`
  padding: 15px;
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  background-color: white;
  text-align: justify;
  border-radius: 5px;
  margin: 15px 0px;
`

const Benefit = ({ size, text, img }) => {
  const { t } = useTranslation()

  return (
    <div
      style={{
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        padding: '2px 0px',
      }}
    >
      <img
        alt={'check'}
        src={img}
        style={{
          marginRight: '10px',
          width: size,
          height: size,
          filter:
            size === 24
              ? 'unset'
              : 'invert(45%) sepia(34%) saturate(6443%) hue-rotate(121deg) brightness(97%) contrast(94%)',
        }}
      />
      {t(text)}
    </div>
  )
}

function LoginAirbnb() {
  const { t } = useTranslation()
  const agreement = useSelector(getAirbnbAgreement)
  const dispatch = useDispatch()

  const isDesktop = is.desktop()

  useEffect(() => {
    dispatch({
      type: IntegrationAction.SetAirbnbAgreement,
      payload: false,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChange = () => {
    dispatch({
      type: IntegrationAction.SetAirbnbAgreement,
      payload: !agreement,
    })
  }

  return (
    <Wrapper>
      <img
        src={airbnb}
        alt={'airbnb'}
        style={{
          width: '200px',
          height: '63px',
        }}
      />
      <Card>
        <Title>{t('OUT_4830_airbnb_logging_window_1')}</Title>
        <CardContent>
          <Benefit size={24} img={check} text={'OUT_22_sneak_peak_2'} />
          <Benefit size={24} img={check} text={'OUT_22_sneak_peak_3'} />
          <Benefit size={24} img={check} text={'OUT_22_sneak_peak_4'} />
        </CardContent>
        <Title>{t('OUT_22_sneak_peak_5')}</Title>
      </Card>
      <Card>
        <Title>{t('OUT_4830_airbnb_logging_keeponmind_1')}</Title>
        <CardContent>
          <Benefit
            size={30}
            img={lockdown}
            text={'BED_22719_text_1'}
          />
        </CardContent>
        <CardContent>
          <Benefit
            size={30}
            img={currency}
            text={'OUT_4830_airbnb_logging_keeponmind_3'}
          />
        </CardContent>
        <CardContent>
          <Benefit
            size={30}
            img={duplicate}
            text={'OUT_4830_airbnb_logging_keeponmind_4'}
          />
        </CardContent>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            paddingTop: '10px',
          }}
        >
          <SquareCheckbox.Field
            noSpacing={true}
            value={agreement}
            onChange={onChange}
            isHorizontal={true}
            labelStyle={{
              marginBottom: '0px',
            }}
            inputWrapperStyle={{
              width: '25px',
            }}
            wrapperStyle={{
              maxWidth: '25px',
              zIndex: 0,
            }}
          />
          <Title
            onClick={onChange}
            style={{
              cursor: 'pointer',
            }}
          >
            {t('OUT_4830_airbnb_logging_accept')}
          </Title>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'center',
            marginBottom: isDesktop ? '0px' : '20px',
          }}
          id={'airbnb-button'}
        >
          <div
            style={{
              cursor: 'not-allowed',
              width: '260px',
              height: '34px',
              position: 'absolute',
              zIndex: !agreement ? 10000 : -1,
            }}
          />
          <AirbnbButton disabled={!agreement} />
        </div>
      </Card>
    </Wrapper>
  )
}

export default LoginAirbnb
